import React, { useEffect } from 'react';
import { Table, Button, ButtonGroup, Label } from 'react-bootstrap';
import { toProperCase, getUser } from '../../utils/Common';
import { ThreeDots } from "react-loader-spinner";
export default function SharedUsersTable({ 
  moreUsers, 
  handleUserClick, 
  handleAddUserToBuilder, 
  removeAllBuilderAccess, 
  caps,
  isMobile,
  loadingMoreUsers
}) {
  const isSalesDemoUser = (user) => {
    return user.caps && user.caps.every(cap => cap.accessType === 'SALES_DEMO');
  };

  // Filter out ADMIN users if current user is not ADMIN
  const currentUser = getUser();
  const filteredUsers = currentUser.role === 'ADMIN' 
    ? moreUsers 
    : moreUsers.filter(user => user.role !== 'ADMIN');

  if(loadingMoreUsers) {
    return (
      <div className="d-flex justify-content-center">
        <ThreeDots color="#00BFFF" height={30} width={30} />
      </div>
    );
  }

  if(filteredUsers.length === 0) {
    return null;
  }

  const getOverlappingCaps = (user) => {
    if (!user.caps || !caps) return [];
    return user.caps.map(userCap => {
      const matchingCap = caps.find(cap => cap.capId === userCap.capId);
      return matchingCap || null;
    }).filter(cap => cap !== null);
  };

  useEffect(() => {
    console.log(filteredUsers);
  }, [filteredUsers]);

  return (
    <Table bordered condensed hover className="shared-users-table">
      <thead>
        <tr>
          <th>User Email</th>
          <th>Last Login</th>
          <th>{isMobile ? "Access" : "Camera Access"}</th>
          <th>{isMobile ? "Actions" : "Quick Actions"}</th>
        </tr>
      </thead>
      <tbody>
        {filteredUsers.map(user => (
          <tr key={user.userId}>
            <td>
              <Button
                bsStyle="default"
                onClick={() => handleUserClick(user.userId)}
                className="shared-user-button"
              >
                <div className="shared-user-info">
                  <div className="shared-user-email">{user.email}</div>
                  {user.firstName && (
                    <div className="shared-user-name">
                      {toProperCase(user.firstName)}{user.lastName ? ` ${toProperCase(user.lastName)}` : ''}
                    </div>
                  )}
                  {getUser().role === 'ADMIN' && isSalesDemoUser(user) && (
                    <div className="shared-user-sales-demo-indicator">
                      <Label bsStyle="warning">
                        SALES DEMO (BEDROCK ONLY)
                      </Label>
                    </div>
                  )}
                  {getUser().role === 'ADMIN' && user.role === 'ADMIN' && (
                    <div className="shared-user-admin-indicator">
                      <Label bsStyle="info">
                        ADMIN (HIDDEN FROM REGULAR USERS)
                      </Label>
                    </div>
                  )}
                </div>
              </Button>
            </td>
            <td className="shared-user-action-cell">
              {user.lastLogin ? new Date(user.lastLogin).toLocaleDateString() : 'More than a month ago'}
            </td>
            <td className="shared-user-action-cell">
              {getOverlappingCaps(user).length} Camera{getOverlappingCaps(user).length === 1 ? "" : "s"}
            </td>
            <td className="shared-user-action-cell">
              {isMobile ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <Button 
                    bsSize="xs"
                    onClick={() => handleAddUserToBuilder(user.userId)}
                    style={{ whiteSpace: 'normal', textAlign: 'center' }}
                  >
                    Mark as Employee
                  </Button>
                  <Button 
                    bsSize="xs"
                    bsStyle="danger"
                    onClick={() => removeAllBuilderAccess(user)}
                    style={{ whiteSpace: 'normal', textAlign: 'center' }}
                  >
                    Remove Access
                  </Button>
                </div>
              ) : (
                <ButtonGroup className="shared-user-actions">
                  <Button 
                    bsSize="sm"
                    onClick={() => handleAddUserToBuilder(user.userId)}
                  >
                    Mark as Employee
                  </Button>
                  <Button 
                    bsSize="sm"
                    bsStyle="danger"
                    onClick={() => removeAllBuilderAccess(user)}
                  >
                    Remove Access
                  </Button>
                </ButtonGroup>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
} 